import React from "react";
import PropTypes from 'prop-types';
import { SvgCardDots } from "../svg";
import { getDate } from "../../utils";
import { getDescriptivePaymentProcessorName } from "../../const";

const PaymentMethod = ({ paymentMethod }) => {
    return (
        <div className="card o-bg mb-3">
            <div className="row">
                <div className="col-xl-4 col-lg-3 col-4 p-4">
                    <label>{gettext('Payment processor')}</label>
                    <p>{getDescriptivePaymentProcessorName(paymentMethod.payment_processor)}</p>
                </div>
                <div className="col-xl-4 col-lg-5 col-4 p-4">
                    <label>{gettext('Card number')}</label>
                    {/* Display only last four digits  */}
                    <div className="d-flex align-items-center card-nr">
                        <SvgCardDots />
                        <p className="mb-0 ms-3">{paymentMethod.display_info}</p>
                    </div>
                </div>
                <div className="col-4 p-4">
                    <label>{gettext('Valid until')}</label>
                    {/* Remove day!  */}
                    <p>{getDate(paymentMethod.valid_until)}</p>
                </div>
            </div>
        </div>
    )
}

PaymentMethod.propTypes = {
    paymentMethod: PropTypes.object.isRequired,
}

export default PaymentMethod